import { Bell } from 'lucide-react'
import { useState } from 'react'

import { NotificationDrawer } from '@/shared/components/NotificationDrawer'
import { useNotificationStore } from '@/shared/stores/notification.store'

export default function NotificationBell() {
  const [isOpen, setIsOpen] = useState(false)

  const unreadCount = useNotificationStore((state) => state.unreadCount)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="relative flex h-9.5 w-9.5 items-center justify-center rounded-full border border-black/[0.06] bg-white text-slate-700 shadow-sm transition hover:bg-slate-50 hover:text-indigo-600 dark:border-white/10 dark:bg-slate-900 dark:text-slate-200"
        aria-label="Open Notifications Drawer"
      >
        <Bell className="h-4.5 w-4.5" />

        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex min-h-4.5 min-w-4.5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white shadow-xs animate-in zoom-in">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      <NotificationDrawer open={isOpen} onClose={handleClose} />
    </>
  )
}
